import { render } from "./FooterComponent.vue?vue&type=template&id=6cfea87f&scoped=true"
const script = {}

import "./FooterComponent.vue?vue&type=style&index=0&id=6cfea87f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cfea87f"]])

export default __exports__